import React, { useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { QRCodeCanvas } from "qrcode.react"; // You'll need to install this: npm install qrcode.react
import { Download } from "lucide-react";

interface QRCodeDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
  restaurantName: string;
}

const QRCodeDialog: React.FC<QRCodeDialogProps> = ({
  open,
  onClose,
  url,
  restaurantName,
}) => {
  const { t } = useTranslation();
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (!qrCodeRef.current) return;

    const canvas = qrCodeRef.current.querySelector("canvas");
    if (!canvas) return;

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `${restaurantName}-menu-qr-code.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("qrCode.title")}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center py-4">
          <div ref={qrCodeRef} className="bg-white p-4 rounded-lg">
            <QRCodeCanvas value={url} size={200} />
          </div>
          <p className="text-sm text-center mt-4 text-muted-foreground">
            {t("qrCode.scanDescription")}
          </p>
          <p className="text-xs mt-1 text-center break-all px-4">{url}</p>
        </div>

        <div className="flex justify-center mt-2">
          <Button onClick={handleDownload} className="gap-2">
            <Download className="w-4 h-4" />
            {t("qrCode.download")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QRCodeDialog;
